'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { AskComposer } from '#pplx/frontend/apps/ask/ask-composer/AskComposer.js';
import { useAskComposerSearchModeSelected } from '#pplx/frontend/apps/ask/ask-composer/useAskComposerSearchModeSelected.js';
import { useComposerUrlIntents } from '#pplx/frontend/apps/ask/hooks/composer-url-intent-hooks/useComposerUrlIntents.js';
import { useQueryFillParams } from '#pplx/frontend/apps/ask/hooks/query-fill-params-hooks/useQueryFillParams.js';
import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { useHomeComposerPageIntegration } from '#pplx/frontend/apps/ask/page-components/home/internal/composer-sdk-plugins/useHomeComposerPageIntegration.js';
import { useHomeComposerAcceptedSubmit } from '#pplx/frontend/apps/ask/page-components/home/internal/useHomeComposerAcceptedSubmit.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { useInputActions, useUserInput } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import { useClientRender } from '#pplx/frontend/common/hooks/useClientRender.js';
import { useRef } from 'react';
export function HomeComposerPage({ recessedFrame = false, }) {
    const inputFocusRef = useRef(null);
    const selectedSearchMode = useSelectedSearchMode();
    const inputQuery = useUserInput();
    const { setUserInput } = useInputActions();
    const { initialConfiguredModelIsLoading } = useThreadConfig();
    const hasMounted = useClientRender();
    const onSearchModeSelected = useAskComposerSearchModeSelected({ surface: 'home' });
    const onAcceptedSubmit = useHomeComposerAcceptedSubmit();
    const pageIntegration = useHomeComposerPageIntegration({
        inputFocusRef,
        inputQuery,
        onSearchModeSelected,
        recessedFrame,
        selectedSearchMode,
    });
    useQueryFillParams({ setUserInput });
    useComposerUrlIntents({
        isModeReady: hasMounted && !initialConfiguredModelIsLoading,
        onSearchModeSelected,
    });
    return (_jsx(AskComposer, { surface: "home", inputFocusRef: inputFocusRef, onAcceptedSubmit: onAcceptedSubmit, pageIntegration: pageIntegration, recessedFrame: recessedFrame }));
}
//# sourceMappingURL=HomeComposerPage.js.map